export const googleAuthConfig = {
  clientId: "750379347440-mp8am6q8hg41lvkn8pi4jku3eq7ts2lq.apps.googleusercontent.com",
  idScope: "email profile openid",
  accessScope: " https://www.googleapis.com/auth/drive.file",
};
